exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "/* fonts.css */\n@font-face {\n    font-family: 'Segoe UI';\n    src: url(" + require("../../assets/fonts/segoeui-regular.woff2") + ") format('woff2');\n    font-weight: 400;\n}\n\n@font-face {\n    font-family: 'Segoe UI';\n    src: url(" + require("../../assets/fonts/segoeui-semibold.woff2") + ") format('woff2');\n    font-weight: 600;\n}\n\n@font-face {\n    font-family: 'Segoe UI';\n    src: url(" + require("../../assets/fonts/segoeui-bold.woff2") + ") format('woff2');\n    font-weight: 700;\n}", ""]);

// exports
